import { DataTable, DataTableColumn } from "mantine-datatable";
import { useEffect, useRef, useState } from "react";
import { useFetchData } from "../../../hooks/useFetch";
import { API_PROMOTION_CAMPAIGN_TYPES_ROUTER, ApiConfig } from "../../../services/api-config";
import { PAGE_SIZES, STATUS, } from "../../../constants/status";
import { PromotionBrand } from "../../../models/response/promotion-brand";
import { PromotionAssignBrandFilter } from "./promotion-assign-brand-filter";
import SwitchButtom from "../../../components/custom/switch-buttom";
import { showToast } from "../../../components/custom/custom-toast";
import { ModalCustom } from "../../../components/custom/modal-custom";
import { ButtonCustom } from "../../../components/custom/button-custom";
import { IconCheckSuccess, IconEye } from "../../../components/icons/icon-group";
import { BasePaginateResponse } from "../../../services/base-response";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";
import Tippy from "@tippyjs/react";
import { DetailRow } from "../../../components/custom/detail-row";
import IconImageDefault from "../../../assets/icons/ic_image_default.svg";
import ImageCustom from "../../../components/custom/image-custom";

interface PromotionAssignBrandTableProps {
  tableLoading: boolean;
  data: PromotionBrand[];
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  keySearch: string;
  setKeySearch: (value: string) => void;
  handleDataChange: () => void;
}

export const PromotionAssignBrandTable = (props: PromotionAssignBrandTableProps) => {
  const {
    tableLoading,
    data = [],
    page,
    pageSize,
    setPage,
    setPageSize,
    keySearch,
    setKeySearch,
    handleDataChange
  } = props;

  const [tableMaxHeight, setTableMaxHeight] = useState(0);
  const [resetModal, setResetModal] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const selectedPromotionBrand = useRef<PromotionBrand>(new PromotionBrand());
  const [promotionCampaigns, setPromotionCampaigns] = useState<PromotionCampaign[]>([]);
  const preMessage = useRef<string>('Gán')

  const initialRecords = data.slice(0, pageSize);
  const [recordsData, setRecordsData] = useState(initialRecords);

  useEffect(() => {
    setPage(1);
  }, [pageSize, keySearch]);

  useEffect(() => {
    const from = (page - 1) * pageSize;
    const to = from + pageSize;
    setRecordsData(data.slice(from, to));
  }, [page, pageSize, data]);

  const { request: getPromotionsCampaign, baseResponse: promotionsCampaignRes, loading: tableLoadingPromotionCampaignType } = useFetchData.Get<BasePaginateResponse<PromotionCampaign[]>>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE });
  const { request: assignPromotionBrandApi, baseResponse: assignPromotionBrandRes, } = useFetchData.Post<{}>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE, });

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        page: 1,
        limit: PAGE_SIZES[1],
        key_search: "",
        type: '-1'
      };
      await getPromotionsCampaign({
        endPoint: API_PROMOTION_CAMPAIGN_TYPES_ROUTER.API_GET_PROMOTION_CAMPAIGNS(),
        data: params,
      });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!promotionsCampaignRes) return;
    if (promotionsCampaignRes?.data && promotionsCampaignRes?.status === 200) {
      setPromotionCampaigns(promotionsCampaignRes.data.list);
    } else {
      showToast({
        message: promotionsCampaignRes?.message ?? "Không thể tải danh sách khuyến mãi",
        type: "error",
      });
    }
  }, [promotionsCampaignRes]);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      const filter = document.getElementById("filter-bar") as HTMLElement;

      if (header && filter) {
        const headerHeight = header.offsetHeight;
        const filterHeight = filter.offsetHeight;
        const remainingHeight =
          window.innerHeight -
          headerHeight -
          filterHeight -
          24 -
          24 -
          40 -
          24;
        setTableMaxHeight(remainingHeight);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const activateAll = (item: PromotionBrand) => {
    const isAllActive = item.promotions.every((promotion) => promotion.is_checked === STATUS.ACTIVE);
    return isAllActive;
  };

  const assignPromotionBrand = async (id: string, types: string[]) => {
    const currentPromotionTypes = selectedPromotionBrand.current.promotions.filter((promotion) => promotion.is_checked === STATUS.ACTIVE).map((promotion) => promotion._id);
    switch (true) {
      case types.length === 0 && currentPromotionTypes.length === promotionCampaigns.length:
        preMessage.current = 'Bỏ gán tất cả';
        break;
      case types.length === promotionCampaigns.length:
        preMessage.current = 'Gán tất cả';
        break;
      case types.length > currentPromotionTypes.length:
        preMessage.current = 'Gán';
        break;
      default:
        preMessage.current = 'Bỏ gán';
        break;
    }

    await assignPromotionBrandApi({
      endPoint: API_PROMOTION_CAMPAIGN_TYPES_ROUTER.API_ASSIGN_PROMOTION_BRAND(),
      data: {
        brand_id: id,
        promotion_campaign_type_ids: types
      },
    })
  }

  useEffect(() => {
    if (!assignPromotionBrandRes) return;
    if (assignPromotionBrandRes.status === 200) {
      handleDataChange();
      showToast({
        type: "success",
        message: `${preMessage.current} khuyến mãi thành công`,
      });
    } else {
      showToast({
        type: "error",
        message: `${preMessage.current} khuyến mãi thất bại`,
      });
    }
  }, [assignPromotionBrandRes]);

  const handleDetailClick = (item: PromotionBrand) => {
    setDetailModal(true)
    selectedPromotionBrand.current = item;
  };

  const bodyModal = () => {
    return (
      <div className="flex flex-col justify-center items-center">
        <IconCheckSuccess className="w-16 h-16 mb-3" />
        <p className="text-center">Dữ liệu đã thay đổi sẽ bị reset. Bạn có chắc chắn muốn tiếp tục?</p>
      </div>
    )
  }

  const bodyDetailModal = () => {
    return (
      <div className="flex flex-col gap-2">
        <div className="flex justify-center items-center">
          <div className="">
            <ImageCustom
              isReview={true}
              url={selectedPromotionBrand.current.logo}
              className="rounded-lg object-fit h-[15.625rem] w-[15.625rem]"
              isLocal={false}
              fallBackUrl={IconImageDefault}
            />
          </div>
        </div>
        <DetailRow label="Tên thương hiệu:" value={selectedPromotionBrand.current.name} />
        {/* <DetailRow label="Khuyến mãi đang bật:" value={selectedPromotionBrand.current.promotions.filter((promotion) => promotion.is_checked === STATUS.ACTIVE).map((promotion) => promotion.name).join(", ")} />
        <DetailRow label="Khuyến mãi đang tắt:" value={selectedPromotionBrand.current.promotions.filter((promotion) => promotion.is_checked === STATUS.INACTIVE).map((promotion) => promotion.name).join(", ")} /> */}
        <DetailRow label="Số điện thoại:" value={selectedPromotionBrand.current.phone} />
        <DetailRow label="Mô tả:" value={selectedPromotionBrand.current.description} />
      </div>
    )
  }

  const footerModal = () => (
    <>
      <ButtonCustom
        type="button"
        text="Huỷ bỏ"
        onClick={() => {
          setResetModal(false);
        }}
        className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
      />
      <ButtonCustom
        type="button"
        text="Xác nhận"
        onClick={() => {
          setResetModal(false)
        }}
      />
    </>
  );

  const generateColumns = (): DataTableColumn<PromotionBrand>[] => {
    return promotionCampaigns.map(promotionCampaignType => ({
      accessor: `${promotionCampaignType._id}`,
      title: (
        <Tippy content={<span>{promotionCampaignType.description}</span>}>
          <span>{promotionCampaignType.name}</span>
        </Tippy>
      ),
      width: "10%",
      titleClassName: "!text-center",
      textAlignment: "center",
      render: (record: PromotionBrand) => {
        const isChecked = record.promotions.some(
          (promotion) => promotion._id === promotionCampaignType._id && promotion.is_checked === STATUS.ACTIVE
        );

        const promotionTypeIdsToUpdate = record.promotions
          .filter((promotion) => promotion._id !== promotionCampaignType._id && promotion.is_checked === STATUS.ACTIVE)
          .map((promotion) => promotion._id);

        if (!isChecked) {
          promotionTypeIdsToUpdate.push(promotionCampaignType._id);
        }

        return (
          <div className="flex justify-center">
            <SwitchButtom
              isChecked={isChecked}
              setIsChecked={(bool) => {
                selectedPromotionBrand.current = record;
                assignPromotionBrand(record._id, promotionTypeIdsToUpdate);
              }}
            />
          </div>
        );
      }
    }));
  };

  return (
    <div className="panel flex flex-col gap-3">
      <PromotionAssignBrandFilter
        searchValue={keySearch}
        setSearchValue={setKeySearch}
      />
      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={tableLoading && tableLoadingPromotionCampaignType}
          withColumnBorders
          noRecordsText="Không có kết quả nào phù hợp với truy vấn tìm kiếm"
          highlightOnHover
          className="whitespace-nowrap table-hover custom-scroll"
          records={recordsData}
          columns={[
            {
              accessor: "_id",
              title: "STT",
              width: "5%",
              textAlignment: "center",
              render: (record, index) => <div>{(page - 1) * pageSize + index + 1}</div>
            },
            {
              accessor: "name",
              title: "Tên thương hiệu",
              width: "15%",
              titleClassName: "!text-center",
              render: (record) => <div className="">{record.name}</div>
            },
            {
              accessor: "phone",
              title: "Số điện thoại",
              width: "5%",
              titleClassName: "!text-center",
              render: (record) => <div className="">{record.phone}</div>
            },
            ...generateColumns(),
            {
              accessor: "all",
              title: "Tất cả",
              titleClassName: "!text-center",
              width: "10%",
              render: (record) => {
                const isChecked = activateAll(record)
                return (
                  <div className="flex justify-center">
                    <SwitchButtom
                      isChecked={isChecked}
                      setIsChecked={(bool) => {
                        selectedPromotionBrand.current = record;
                        const newPromotionCampaigns = isChecked ? [] : record.promotions.map(promotion => promotion._id);
                        assignPromotionBrand(record._id, newPromotionCampaigns);
                      }}
                    />
                  </div>
                )
              }
            },
            {
              accessor: "action",
              title: "Action",
              titleClassName: "!text-center bg-info",
              width: "5%",
              render: (record) => (
                <div className="flex items-center w-max mx-auto gap-2">
                  <Tippy content="Chi tiết">
                    <button type="button" data-testid="btn-detail" onClick={() => handleDetailClick(record)}>
                      <IconEye />
                    </button>
                  </Tippy>
                </div>
              )
            },
          ]}
          totalRecords={data.length}
          recordsPerPage={pageSize}
          page={page}
          onPageChange={(p) => setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={setPageSize}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) =>
            `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`
          }
        />

        <ModalCustom
          isOpen={resetModal}
          setIsOpen={setResetModal}
          titleModal="Thông báo"
          bodyModal={bodyModal()}
          footerModal={footerModal()}
          modalSize="lg"
        />

        <ModalCustom
          isOpen={detailModal}
          setIsOpen={setDetailModal}
          titleModal="Chi tiết"
          bodyModal={bodyDetailModal()}
          footerModal={null}
          modalSize="lg"
        />
      </div>
    </div>
  );
};
